import { createContext } from 'react';

import { UbiquitiISPMetric } from '@totem/components/ubiquiti/types';

interface Context {
  loading: boolean;
  error: boolean;
  metrics: UbiquitiISPMetric[];
  duration: string;
  setDuration: (duration: string) => void;
}

export default createContext<Context>({
  loading: false,
  error: false,
  metrics: [],
  duration: '1',
  setDuration: () => {},
});
